import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue";
import _imports_0 from '@/assets/images/icon-logo@3x.png';
const _hoisted_1 = ["styles"];
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"c-download-top-wrap\"><img class=\"c-download-top-logo\" src=\"" + _imports_0 + "\" alt=\"\"><dl class=\"c-download-top-dl\"><dt class=\"c-download-top-dt\">CFMOTO</dt><dd class=\"c-download-top-dd\">你的摩托车社区</dd></dl><button type=\"button\" class=\"c-download-top-btn moblink-app\">打开APP</button></div>", 1);
const _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return !_ctx.isApp ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "c-download-top",
    styles: $options.styles
  }, _hoisted_3, 8, _hoisted_1)) : _createCommentVNode("", true);
}